var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon21(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0283 16.8767L17.5 10.25",
    stroke: "#155DFC",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3338 4.99998L6.32209 12.155C6.00964 12.4675 5.83411 12.8914 5.83411 13.3333C5.83411 13.7753 6.00964 14.1991 6.32209 14.5116C6.63464 14.8241 7.05848 14.9996 7.50042 14.9996C7.94236 14.9996 8.36621 14.8241 8.67876 14.5116L15.6904 7.35665C16.3153 6.73155 16.6664 5.88386 16.6664 4.99998C16.6664 4.1161 16.3153 3.26841 15.6904 2.64331C15.0653 2.01841 14.2176 1.66736 13.3338 1.66736C12.4499 1.66736 11.6022 2.01841 10.9771 2.64331L3.96459 9.79748C3.02683 10.7352 2.5 12.0071 2.5 13.3333C2.5 14.6595 3.02683 15.9314 3.96459 16.8691C4.90235 17.8069 6.17423 18.3337 7.50042 18.3337C8.82662 18.3337 10.0985 17.8069 11.0363 16.8691",
    stroke: "#155DFC",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon21);
export default __webpack_public_path__ + "static/media/icon21.1a79fdcba60486130da43f08dcaa3744.svg";
export { ForwardRef as ReactComponent };